import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal, Form, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import config from '../config/config';
import { useResto } from '../contexts/RestoContext';
import { useMode } from '../contexts/ModeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { ucfirst } from '../utils/utils';
import MediaList from './MediaList';

function FaqItem({ faq, handleDelete, handleRankingUpdate, handleEdit, isFirst, isLast }) {
    const { t } = useTranslation();
    const { isModeAdmin } = useMode();
    const { restoData } = useResto();
    const { activeLanguage } = useLanguage();
    const availableLanguages = restoData.availableLanguages;

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editedFaq, setEditedFaq] = useState({
        ...faq,
    });

    const handleTrashClick = () => {
        setShowConfirmation(true);
    };
    
    const handleCloseConfirmation = () => {
        setShowConfirmation(false);
    };
    
    const handleConfirmDelete = () => {
        handleDelete(faq.id);
        setShowConfirmation(false);
    };
    
    const handleRanking = (direction) => {
        handleRankingUpdate(direction, faq.id);
    };

    const handleEditClick = () => {
        setEditedFaq({
            ...faq,
        });
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
    };

    const handleEditSubmit = () => {
        handleEdit(faq.id, editedFaq);
        setShowEditModal(false);
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setEditedFaq(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    return (
        <div className="kubuni-frame" style={{ paddingBottom: '20px' }}>
            {isModeAdmin && 
            <>
                {availableLanguages.map(language => (
                <div key={language}>
                    <div style={{ fontWeight: 'bold' }}><Image src={`${config.kubuniImagesUrl}general-icons/flag_${language}_icon_24.png`} className="flag-label" alt={`${language}`} /> {faq[`question${ucfirst(language)}`]}</div>
                    <div style={{ fontWeight: 'normal' }}>{faq[`answer${ucfirst(language)}`]}</div>
                </div>
                ))}

                <div style={{ marginTop: '10px' }}>
                    <Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }} onClick={handleEditClick}>
                        <FontAwesomeIcon icon={faEdit} />
                    </Button>
                    {!isFirst && (<Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }} onClick={() => handleRanking('up')}>
                        <FontAwesomeIcon icon={faAngleUp} />
                    </Button>)}
                    {!isLast && (<Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }} onClick={() => handleRanking('down')}>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </Button>)}
                    <Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }} onClick={handleTrashClick}>
                        <FontAwesomeIcon icon={faTrash} />
                    </Button>
                </div>
                <MediaList mediaKey={'FAQ' + faq['id']} maxItems={10} />
                <Modal show={showConfirmation} onHide={handleCloseConfirmation}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('CONFIRM_DELETE')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t('CONFIRM_DELETE_MESSAGE')}</p>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button variant="secondary" onClick={handleCloseConfirmation}>
                            {t('CANCEL')}
                        </Button>
                        <Button variant="primary" onClick={handleConfirmDelete}>
                            {t('CONFIRM')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showEditModal} onHide={handleCloseEditModal} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>{t('EDIT')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            {restoData.availableLanguages.map(language => (
                                <div key={language}>
                                    <Form.Group controlId={`editQuestion${ucfirst(language)}`}>
                                        <Form.Label>Question <Image src={`${config.kubuniImagesUrl}general-icons/flag_${language}_icon_24.png`} className="flag-label" alt={`Label ${language}`} /></Form.Label>
                                        <Form.Control 
                                                    type="string"
                                                    name={`question${ucfirst(language)}`} 
                                                    value={editedFaq[`question${ucfirst(language)}`]} 
                                                    onChange={handleEditInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId={`editAnswer${ucfirst(language)}`}>
                                        <Form.Label>Réponse <Image src={`${config.kubuniImagesUrl}general-icons/flag_${language}_icon_24.png`} className="flag-label" alt={`Label ${language}`} /></Form.Label>
                                        <Form.Control as="textarea"
                                                      rows={3} 
                                                      name={`answer${ucfirst(language)}`} 
                                                      value={editedFaq[`answer${ucfirst(language)}`]} 
                                                      onChange={handleEditInputChange} />
                                    </Form.Group>
                                </div>
                            ))}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button variant="secondary" onClick={handleCloseEditModal}>
                            {t('CANCEL')}
                        </Button>
                        <Button variant="primary" onClick={handleEditSubmit}>
                            {t('CONFIRM')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>}
            {!isModeAdmin && 
                <div>
                    <div style={{ fontWeight: 'bold' }}>{faq[`question${ucfirst(activeLanguage)}`]}</div>
                    <div style={{ fontWeight: 'normal' }}>{faq[`answer${ucfirst(activeLanguage)}`]}</div>
                    <MediaList mediaKey={'FAQ' + faq['id']} maxItems={10} />
                </div>
            }
        </div>
    );
}

export default FaqItem;